import { Component, OnInit } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { page } from '../class/status';
import { menulist } from '../class/status';

@Component({
    selector: 'app-promotion-record',
    templateUrl: './promotion-record.component.html',
    styleUrls: ['./promotion-record.component.css']
})
export class PromotionRecordComponent implements OnInit {

    pageobj:page = {page:0,count:10,total_count:0};
    now:string='0';
    loading:boolean=false;
    data:any = [];
    datadetail:any = [];
    menu_list:menulist = [{id:'0',name:'推播紀錄'}]
    tcontent = [
        {title:'發送日期',content:'pm_time'},
        {title:'推送訊息數量',content:'pm_num'},
        {title:'發送到長時間未上線數量',content:'no_login_num'},
        {title:'建立時間',content:'create_dt'},
        {title:'觀看詳細',content:'detail',type:3},

      ];

    tcontent2 = [
        {title:'發送標題',content:'title'},
        {title:'發送內容',content:'content'},
        {title:'預覽圖',content:'img',type:3},
        {title:'發送對象',content:'name',type:3},
        {title:'最後上線時間',content:'last_singin_date'},
        {title:'發送時間最後上線時間',content:'time_elapsed'},
      ];  

    constructor(public httpClient: HttpClient,) { }

    ngOnInit(): void {
        this.init_list();
    
    }

    viewAll(item){

        const body = {data:item,act:1};
        this.loading = true;
        this.httpClient.post<any>("/v1/common/get_promotion_list.php",body).subscribe(res => {
            if(res.status){
                this.loading = false;
                this.datadetail = res.data;
            }
        });    
    
    }

    choose(value:string){
        this.now = value;
        this.pageobj.page = 0;
        this.init_list();
    }
  
    init_list(){
        this.loading = true; 
        const body = {page: this.pageobj.page,count:this.pageobj.count,type:this.now,act:0};
        this.httpClient.post<any>("/v1/common/get_promotion_list.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.data = res.data;
            }
        });    
    }

}
